import React, { useEffect, useState } from 'react';
import { Checkbox, withStyles, Modal } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { PictureDetailField } from './PictureDetailModal';
import { PictureImage } from './PictureImage';
import { useStyles } from '../parts/cloudStorage/style/style';
import type { TSharedPicture } from '../../types/cloudStorage/CloudFileList';

type Tprops = {
  picture: TSharedPicture;
  addSelectedPictures: () => void;
  removeSelectedPictures: () => void;
  selectedPictures: TSharedPicture[];
  setSelectedPictures: React.Dispatch<React.SetStateAction<TSharedPicture[]>>;
  getSharedPictureList: () => void;
  setDeleteModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isGuestPicture: boolean;
};

export const PictureList: React.FC<Tprops> = (props: Tprops) => {
  const {
    picture,
    addSelectedPictures,
    removeSelectedPictures,
    selectedPictures,
    setSelectedPictures,
    getSharedPictureList,
    setDeleteModalOpen,
    isGuestPicture
  } = props;

  const classes = useStyles();

  const [detailModalOpen, setDetailModalOpen] = useState<boolean>(false);

  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked: boolean = event.target.checked;
    if (checked) {
      addSelectedPictures();
    } else {
      removeSelectedPictures();
    }
  };

  useEffect(() => {}, [selectedPictures]);

  return (
    <>
      <div style={{ marginRight: 16, position: 'relative' }}>
        <PictureCheckbox
          checked={
            selectedPictures.find(
              selectedPicture => selectedPicture.id === picture.id
            )
              ? true
              : false
          }
          onChange={handleCheck}
          color='default'
          size='small'
          style={{ position: 'absolute', top: 5, left: 5 }}
        />

        {isGuestPicture && (
          <div
            className={classes.pictureEditIcon}
            onClick={() => setDetailModalOpen(true)}
          >
            <EditIcon />
          </div>
        )}

        <div>
          <PictureImage
            picture={picture}
            setDetailModalOpen={setDetailModalOpen}
            src={picture.src}
          />
        </div>
      </div>

      {/* 写真詳細表示モーダル */}
      <Modal
        open={detailModalOpen}
        onClose={() => setDetailModalOpen(false)}
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        className={classes.container}
      >
        <PictureDetailField
          picture={picture}
          getSharedPictureList={getSharedPictureList}
          setDetailModalOpen={setDetailModalOpen}
          setSelectedPictures={setSelectedPictures}
          setDeleteModalOpen={setDeleteModalOpen}
          isGuestPicture={isGuestPicture}
        />
      </Modal>
    </>
  );
};

const PictureCheckbox = withStyles({
  root: {
    backgroundColor: '#fff'
  },
  checked: {}
})(Checkbox);
